"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.recording.active': 'Recording Active',
    'conversation.recording.inactive': 'Recording Inactive',
};
